// Copyright 2026, University of Maryland, All Rights Reserved
import { type FC, type ReactNode } from 'react'
import { Label } from '@/components/ui'
import { cn } from '@/lib/utils'

export interface FieldProps {
  label: ReactNode
  htmlFor?: string
  helper?: ReactNode
  error?: ReactNode
  className?: string
  children: ReactNode
}

export const Field: FC<FieldProps> = ({ label, htmlFor, helper, error, className, children }) => (
  <div className={cn('space-y-1 min-w-0', className)}>
    <Label htmlFor={htmlFor}>{label}</Label>
    {children}
    {error ? (
      <p className="text-xs text-destructive">{error}</p>
    ) : helper ? (
      <p className="text-xs text-muted-foreground">{helper}</p>
    ) : null}
  </div>
)
